import { HDate, HebrewCalendar, flags as F } from '@hebcal/core';

/**
 * Compute motzaei Shabbat flags.
 * Only meaningful on Saturday night (dayOfWeek === 6).
 *
 * @param {HDate} hdate - Saturday's halachic date
 * @param {boolean} isIsrael
 * @returns {object}
 */
export function computeMotzaeiShabbat(hdate, isIsrael) {
  if (hdate.getDay() !== 6) {
    return { vihiNoam: false, vayitenLecha: false };
  }

  // ═══ Vihi Noam (Psalm 91) ═══
  // SKIP if any Yom Tov falls during the coming week (Sunday through Friday)
  const sunday = new HDate(hdate.abs() + 1);
  const friday = new HDate(hdate.abs() + 6);
  const weekEvents = HebrewCalendar.calendar({
    start: sunday,
    end: friday,
    il: isIsrael,
  });
  const hasYTThisWeek = weekEvents.some(e => e.getFlags() & F.CHAG);
  const vihiNoam = !hasYTThisWeek;

  // ═══ VaYiten Lecha ═══
  // SKIP if motzaei Shabbat leads into Yom Tov or Chol HaMoed
  const tomorrowEvents = HebrewCalendar.calendar({
    start: sunday,
    end: sunday,
    il: isIsrael,
  });
  const isTomorrowYTOrCHM = tomorrowEvents.some(e =>
    (e.getFlags() & F.CHAG) || (e.getFlags() & F.CHOL_HAMOED)
  );
  const vayitenLecha = !isTomorrowYTOrCHM;

  return { vihiNoam, vayitenLecha };
}
